import html2canvas from 'html2canvas';

window.onload = () => {
    const root = document.documentElement;

    const degree = document.getElementById("degree");
    const speed = document.getElementById("speed");
    const inputtext = document.getElementById("text");
    const fontsize = document.getElementById("fontsize");
    
    const texts = document.querySelectorAll(".container__text");

    degree.addEventListener("change", (e) => {
        root.style.setProperty('--degree-min', -1 * e.target.value);
        root.style.setProperty('--degree-max', e.target.value);
    });

    speed.addEventListener("change", (e) => {
        root.style.setProperty('--speed', e.target.value+"s");
    });

    inputtext.addEventListener("input", (e) => {
        texts.forEach(text => {
            text.innerHTML = e.target.value;
        })
    })

    fontsize.addEventListener('change', (e) => {
        root.style.setProperty('--fontsize', e.target.value+"px");
    })
}
